import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function PlanIntervalToggleBtn(props) {
  const classes = clsx({
    planTypeToggleBtn: true,
    'planTypeToggleBtn--selected': props.selected,
  });

  return (
    <a className={classes} onClick={props.onClick}>
      <div>{props.name}</div>
      <div className="planTypeToggleBtn_subtitle">{props.subtitle}</div>
    </a>
  );
}

class PlanIntervalToggleBar extends Component {
  handlePlanIntervalChange = (interval) => {
    this.props.onPlanIntervalChange(interval);
  }

  render() {
    const { intervals, selectedPlanInterval } = this.props;

    return (
      <div className="planTypeToggleBar">
        {intervals.map(interval => (
          <PlanIntervalToggleBtn
            key={interval.key}
            name={interval.title}
            subtitle={interval.subtitle}
            selected={selectedPlanInterval === interval.key}
            onClick={() => this.handlePlanIntervalChange(interval.key)}
          />
        ))}
      </div>
    );
  }
}

PlanIntervalToggleBar.propTypes = {
  intervals: PropTypes.array.isRequired,
  selectedPlanInterval: PropTypes.string.isRequired,
  onPlanIntervalChange: PropTypes.func.isRequired,
};

export default PlanIntervalToggleBar;
